module.exports = __webpack_public_path__ + "media/bootstrap-icons/octagon-fill-978db8be.svg";